// backup.js -- legacy pre-v2 export at /jsrecon/api/legacy/backup